import { AxiosResponse } from "axios";
import {
  ICommitment,
  ICreateCommitmentData,
  ICreateFirstCommitmentData,
  ICreateFirstCommitmentResponse,
  IUpdateCommitmentData,
  IImportedCommitment
} from "store/types";
import { toFormData } from "utils";
import downloadFileAxios from "utils/download-file-axios";
import { DealAction } from "..";
import { AsyncActions, AsyncActionsParams } from "../base";

export interface ICommitmentActions {
  createCommitmentAction: (data: ICreateCommitmentData) => Promise<void>;
  deleteCommitmentAction: (data: ICommitment) => Promise<void>;
  updateCommitmentAction: (data: IUpdateCommitmentData) => Promise<ICommitment>;
  createFirstCommitmentAction: (data: ICreateFirstCommitmentData) => Promise<ICreateFirstCommitmentResponse>;
  importCommitmentAction: (data: { file: File; round_id: number }) => Promise<IImportedCommitment[]>;
  downloadCommitmentsTemplateAction: () => void;
}

export class CommitmentActions extends AsyncActions implements ICommitmentActions {
  public constructor(params: AsyncActionsParams) {
    super(params);
  }
  public createCommitmentAction = async (data: ICreateCommitmentData): Promise<void> => {
    try {
      const {
        data: { data: payload }
      }: AxiosResponse<{ data: ICommitment }> = await this.api.post({
        url: "/api/v0.0.3/deals/commitments",
        data: {
          ...data
        }
      });
      this.dispatch({ type: DealAction.CreateCommitmentSuccess, payload });
    } catch (error) {
      throw error;
    }
  };

  public deleteCommitmentAction = async (data: ICommitment): Promise<void> => {
    try {
      await this.api.delete({
        url: `/api/v0.0.3/deals/commitments/${data.id}`
      });
      this.dispatch({
        type: DealAction.DeleteCommitmentSuccess,
        payload: data
      });
    } catch (error) {
      throw error;
    }
  };

  public updateCommitmentAction = async (data: IUpdateCommitmentData): Promise<ICommitment> => {
    try {
      const { id, investor_id, amount } = data;
      const {
        data: { data: payload }
      }: AxiosResponse<{ data: ICommitment }> = await this.api.patch({
        url: `/api/v0.0.3/deals/commitments/${id}`,
        data: {
          investor_id,
          amount
        }
      });
      this.dispatch({ type: DealAction.UpdateCommitmentSuccess, payload });
      return payload;
    } catch (error) {
      throw error;
    }
  };

  public createFirstCommitmentAction = async (
    data: ICreateFirstCommitmentData
  ): Promise<ICreateFirstCommitmentResponse> => {
    try {
      const {
        data: { data: payload }
      }: AxiosResponse<{ data: ICreateFirstCommitmentResponse }> = await this.api.post({
        url: "/api/v0.0.3/deals/first-commitment",
        data: {
          ...data
        }
      });

      this.dispatch({ type: DealAction.CreateFirstCommitmentSuccess, payload });
      return payload;
    } catch (error) {
      throw error;
    }
  };

  public importCommitmentAction: ICommitmentActions["importCommitmentAction"] = async (
    body
  ): Promise<IImportedCommitment[]> => {
    const { data } = await this.api.post({
      url: "/api/v0.0.3/deals/commitments/import",
      data: toFormData(body),
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    return data.data;
  };

  public downloadCommitmentsTemplateAction = async (): Promise<void> => {
    return this.api
      .get({
        url: "/api/v0.0.3/deals/commitments/template/download",
        responseType: "blob"
      })
      .then(downloadFileAxios);
  };
}
